import { ArrowDropDown } from '@mui/icons-material';
import React, { useState } from 'react'
import styles from "../css/SetupPage.module.css";

let cursorOverMenu
const OptionsWrapper = ({ elements }) => {
    const [menuState, setMenuState] = useState(false)
    return (
        <button id={styles.setupMenuWrapper} onMouseOver={e => cursorOverMenu = true} onMouseLeave={e => cursorOverMenu = false} autoFocus={true} onBlur={e => !cursorOverMenu && menuState && setMenuState(false)}>
            <button id={styles.setupMenuToggler} className={menuState ? styles.active : ''} onClick={e => setMenuState(!menuState)}>
                Options <ArrowDropDown />
            </button>
            {menuState && <div id={styles.setupMenu}>{elements}</div>}
        </button>
    )
}

export default OptionsWrapper